import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { Formik, Form } from 'formik';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { validationMessages } from '../../../i18n/common';
import DeleteTeamReportForm from './DeleteTeamReportForm';
import useSubscriptionExpiredRestrictions from '../../../hooks/useSubscriptionExpiredRestrictions';

const i18n = defineMessages({
  header: {
    id: 'del_header.executive_report',
    defaultMessage: 'Delete Executive Report',
  },
});

const DeleteTeamReport = ({ reject, confirm, modalOpen }) => {
  const { formatMessage } = useIntl();
  const { reportId } = useParams();

  const { subscriptionIsExpired } = useSubscriptionExpiredRestrictions();

  const initialValues = {
    confirmation_code: reportId,
    re_confirmation_code: '',
  };
  const validationSchema = Yup.object().shape({
    confirmation_code: Yup.string().required(formatMessage(validationMessages.required)),
    re_confirmation_code: Yup.string()
      .oneOf([Yup.ref('confirmation_code'), null], validationMessages.sameAs)
      .required(formatMessage(validationMessages.required)),
  });
  const modalHeader = formatMessage(i18n.header);
  const dialogFooter = (
    <>
      <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
        {(text) => (
          <Button
            className="p-button-secondary"
            label={text}
            type="submit"
            onClick={reject}
            disabled={subscriptionIsExpired}
          />
        )}
      </FormattedMessage>
      &nbsp;
      <FormattedMessage id="actions.delete" defaultMessage="Delete">
        {(text) => <Button label={text} type="submit" />}
      </FormattedMessage>
    </>
  );
  return (
    <Formik onSubmit={confirm} validationSchema={validationSchema} initialValues={initialValues}>
      {() => {
        return (
          <Form>
            <Dialog header={modalHeader} footer={dialogFooter} visible={modalOpen} onHide={reject} modal>
              <div className="panel panel-no-border">
                <div className="panel-body">
                  <DeleteTeamReportForm reportId={reportId} />
                </div>
              </div>
            </Dialog>
          </Form>
        );
      }}
    </Formik>
  );
};

DeleteTeamReport.propTypes = {
  reject: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
};

export default DeleteTeamReport;
